import React, {useState, useEffect, useRef} from 'react';
import './checkInPage.css';
import ApiService from '../../api/ApiService';
import LocalDataService from '../../api/LocalDataService';
import {toast} from "react-toastify";
import {Col, Row} from "react-bootstrap";

const CheckInPage = () => {
    const [checkedDays, setCheckedDays] = useState([]);
    const [todayChecked, setTodayChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [checkInResult, setCheckInResult] = useState(null);
    const [checkInSummary, setCheckInSummary] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showNonMemberModal, setShowNonMemberModal] = useState(false);
    const [recentHistory, setRecentHistory] = useState([]);
    const [userInfo, setUserInfo] = useState(null);
    const [confetti, setConfetti] = useState([]);
    const confettiContainerRef = useRef(null);

    // 任务相关状态
    const [tasks, setTasks] = useState([]); // 任务列表
    const [currentTaskReward, setCurrentTaskReward] = useState(null); // 当前领取的任务奖励
    const [showTaskRewardModal, setShowTaskRewardModal] = useState(false); // 显示任务奖励弹窗
    const [taskConfetti, setTaskConfetti] = useState([]); // 任务奖励撒花效果
    const taskConfettiContainerRef = useRef(null); // 任务奖励撒花容器引用

    const apiService = new ApiService();


    // 获取会员类型显示文本
    const getMemberTypeText = (level) => {
        switch (level) {
            case 0:
                return '非会员';
            case 1:
                return 'VIP会员';
            case 2:
                return 'SVIP会员';
            default:
                return '非会员';
        }
    };

    // 获取会员类型样式类名
    const getMemberTypeClass = (level) => {
        switch (level) {
            case 1:
                return 'cp-member-type';
            case 2:
                return 'cp-member-type premium';
            default:
                return 'cp-member-type';
        }
    };

    // 格式化用户名称，最多显示5个字符
    const formatUserName = (name) => {
        if (!name) return '未登录';
        if (name.length <= 5) return name;
        return name.substr(0, 5) + '...';
    };

    // 获取签到数据和记录的函数
    const fetchCheckInData = async () => {
        try {
            console.log('刷新签到数据...');

            // 调用API获取签到历史记录
            const response = await apiService.get_check_in_history();
            console.log('最新签到历史响应:', response);

            if (response.code === 200 && response.data && response.data.dates) {
                // 设置签到数据摘要
                setCheckInSummary({
                    totalCheckIns: response.data.days,
                    allUsersTotal: response.data.rewardTimes,
                    allUsersTotalAmount: response.data.reward / 100
                });

                // 提取签到日期
                const checkInDates = response.data.dates.map(item => item.isSign ? item.date : null).filter(date => date !== null);
                setCheckedDays(checkInDates);

                // 设置最近的签到记录
                setRecentHistory(response.data.dates.map(item => item.isSign ? ({
                    date: item.date,
                    amount: item.reward / 100
                }) : null).filter(date => date !== null).slice(0, 5));

                // 检查今天是否已签到
                setTodayChecked(response.data.today);
                console.log('签到数据刷新成功');
            }
        } catch (error) {
            console.error('刷新签到数据失败:', error);
        }
    };

    // 获取任务列表
    const fetchTasks = async (token) => {
        try {
            console.log('开始获取任务列表...');
            const response = await apiService.get_tasks(token);
            console.log('任务列表接口返回:', response);
            if (response && Array.isArray(response)) {
                setTasks(response);
            } else {
                console.error('获取任务列表失败: 返回格式不正确');
            }
        } catch (error) {
            console.error('获取任务列表失败:', error);
        }
    };

    useEffect(() => {
        // 获取签到数据和用户信息
        const fetchData = async () => {
            try {
                // 获取用户数据
                const userData = LocalDataService.load_user_data();
                console.log('LocalDataService获取的用户数据:', userData);

                if (!userData) {
                    console.error('未获取到token，用户未登录');
                    toast.error('请先登录');
                    return;
                }

                // await fetchUserInfo(userData.token);
                setUserInfo(userData);
                await fetchCheckInData();
                // await fetchTasks(userData.token);
            } catch (error) {
                toast.error('获取数据失败');
                console.error('获取数据错误:', error);
                setCheckedDays([]);
            }
        };

        fetchData();
        // 添加事件监听器
        const handleUserLoginStatusChange = () => {
            fetchData();
        };

        window.addEventListener('userLoginStatusChanged', handleUserLoginStatusChange);

        return () => {
            window.removeEventListener('userLoginStatusChanged', handleUserLoginStatusChange);
        };
    }, []);

    // 创建撒花效果
    const createConfetti = () => {
        if (!confettiContainerRef.current) return;

        const colors = ['red', 'pink', 'orange', 'yellow', 'gold'];
        const shapes = ['circle', 'rect', 'heart'];
        const newConfetti = [];

        // 创建50个随机彩花
        for (let i = 0; i < 50; i++) {
            const color = colors[Math.floor(Math.random() * colors.length)];
            const shape = shapes[Math.floor(Math.random() * shapes.length)];
            const left = Math.random() * 100; // 随机水平位置
            const delay = Math.random() * 2; // 随机延迟时间
            const size = Math.floor(Math.random() * 6) + 8; // 随机大小
            const rotation = Math.random() * 360; // 随机旋转角度

            newConfetti.push({
                id: i,
                color: color,
                shape: shape,
                left: left,
                delay: delay,
                size: size,
                rotation: rotation
            });
        }

        setConfetti(newConfetti);
    };

    // 显示签到成功弹窗并触发撒花效果
    const showSuccessModalWithConfetti = () => {
        setShowModal(true);
        // 短暂延迟以确保DOM已更新
        setTimeout(() => {
            createConfetti();
        }, 100);
    };

    const handleCheckIn = async () => {
        if (todayChecked) {
            toast.info('今天已经签到过了');
            return;
        }

        // if (userInfo && userInfo.vip.level === 0) {
        //     setShowNonMemberModal(true);
        //     return;
        // }

        setLoading(true);
        try {
            // 从LocalDataService获取用户token
            const userData = LocalDataService.load_user_data();
            if (!userData) {
                toast.error('请先登录');
                setLoading(false);
                return;
            }

            const response = await apiService.check_in();

            if (response.code === 200) {
                // 签到成功
                const today = new Date().toISOString().split('T')[0];

                // 刷新签到数据
                await fetchCheckInData();

                // 更新签到结果
                setCheckInResult(response);

                // 显示签到成功弹窗并触发撒花效果
                showSuccessModalWithConfetti();

                // 刷新任务列表
                // await fetchTasks();

                toast.success(response.msg || '签到成功！');
            } else if (response.code === 400 && response.msg.includes('已签到')) {
                // 今日已签到的情况
                toast.info(response.msg || '您今日已签到，请明天再来！');

                // 刷新签到数据
                await fetchCheckInData();
            } else {
                throw new Error(response.msg || '签到失败');
            }
        } catch (error) {
            let errorMsg = '签到失败，请稍后再试';
            if (error.response && error.response.data && error.response.data.msg) {
                errorMsg = error.response.data.msg;
            } else if (error.message) {
                errorMsg = error.message;
            }
            toast.error(errorMsg);
            console.error('签到错误:', error);
        } finally {
            setLoading(false);
        }
    };

    // 创建从今天起的14天的日历格
    const createDayGrid = () => {
        const today = new Date();
        const days = [];

        for (let i = 0; i < 14; i++) {
            const date = new Date();
            date.setDate(today.getDate() - i);
            const dateString = date.toISOString().split('T')[0];
            const isChecked = checkedDays.includes(dateString);

            // 从签到历史记录中找到对应的奖励
            const historyItem = recentHistory.find(item => item.date === dateString);

            days.push({
                date: dateString,
                isToday: i === 0,
                isChecked: isChecked,
                daysAgo: i,
                reward: historyItem ? historyItem.amount : null
            });
        }

        return days;
    };

    // 计算当前连续签到天数
    const calculateStreakDays = () => {
        const today = new Date();
        let streakDays = 0;

        for (let i = 0; i < 7; i++) {
            const date = new Date();
            date.setDate(today.getDate() - i);
            const dateString = date.toISOString().split('T')[0];

            if (checkedDays.includes(dateString)) {
                streakDays++;
            } else if (i > 0) {
                // 如果中断了，且不是今天，则停止计算
                break;
            }
        }

        return streakDays;
    };

    // 关闭弹窗
    const handleCloseModal = () => {
        setShowModal(false);
        setConfetti([]);
    };

    // 处理开通会员
    const handleBuyMembership = () => {
        // 关闭非会员提示弹窗
        setShowNonMemberModal(false);
        // 跳转到会员套餐页面
        window.location.href = '/vipCenter';
        // toast.info('正在前往会员开通页面...');
    };

    // 关闭非会员提示弹窗
    const handleCloseNonMemberModal = () => {
        setShowNonMemberModal(false);
    };

    // 计算当前的连续签到天数
    const streakDays = calculateStreakDays();
    // 当前连续签到进度比例
    const streakProgress = Math.min(streakDays / 7 * 100, 100);

    // 创建任务奖励撒花效果
    const createTaskConfetti = () => {
        if (!taskConfettiContainerRef.current) return;

        const colors = ['purple', 'violet', 'magenta', 'indigo', 'blue'];
        const shapes = ['circle', 'rect', 'star'];
        const newConfetti = [];

        // 创建50个随机彩花
        for (let i = 0; i < 50; i++) {
            const color = colors[Math.floor(Math.random() * colors.length)];
            const shape = shapes[Math.floor(Math.random() * shapes.length)];
            const left = Math.random() * 100; // 随机水平位置
            const delay = Math.random() * 2; // 随机延迟时间
            const size = Math.floor(Math.random() * 6) + 8; // 随机大小
            const rotation = Math.random() * 360; // 随机旋转角度

            newConfetti.push({
                id: i,
                color: color,
                shape: shape,
                left: left,
                delay: delay,
                size: size,
                rotation: rotation
            });
        }

        setTaskConfetti(newConfetti);
    };

    // 显示任务奖励弹窗并触发撒花效果
    const showTaskRewardModalWithConfetti = () => {
        setShowTaskRewardModal(true);
        // 短暂延迟以确保DOM已更新
        setTimeout(() => {
            createTaskConfetti();
        }, 100);
    };

    // 处理开始任务
    const handleStartTask = (gotoUrl) => {
        if (!gotoUrl) return;
        // 打开新窗口跳转到任务链接
        window.open(gotoUrl, '_blank');
    };

    // 处理领取任务奖励
    const handleClaimTaskReward = async (taskId, taskName, rewardType, cashAmount, vipDays) => {
        try {
            setLoading(true);
            // 从LocalDataService获取用户token
            const userData = LocalDataService.load_user_data();
            if (!userData || !userData.token) {
                toast.error('请先登录');
                setLoading(false);
                return;
            }

            const response = await apiService.get_task_reward(userData.token, taskId);

            // 模拟API调用成功
            setCurrentTaskReward({
                name: taskName,
                rewardType: rewardType,
                cashAmount: cashAmount,
                vipDays: vipDays
            });

            // 显示奖励领取成功弹窗
            showTaskRewardModalWithConfetti();

            // 刷新任务列表
            // await fetchTasks(userData.token);

            if (rewardType === 1) {
                toast.success(`恭喜您获得${(cashAmount / 100).toFixed(2)}元奖励！`);
            } else {
                toast.success(`恭喜您获得${vipDays}天VIP会员！`);
            }
        } catch (error) {
            console.error('领取任务奖励失败:', error);
            toast.error('领取任务奖励失败，请稍后再试');
        } finally {
            setLoading(false);
        }
    };

    // 关闭任务奖励弹窗
    const handleCloseTaskRewardModal = () => {
        setShowTaskRewardModal(false);
        setTaskConfetti([]);
    };

    // 获取任务状态文本
    const getTaskStatusText = (status) => {
        switch (status) {
            case 0:
                return '未开始';
            case 1:
                return '进行中';
            case 2:
                return '已完成';
            default:
                return '未知状态';
        }
    };

    return (
        <div className="cp-page-container">
            <div className="cp-container container">
                <Row className="cp-header">
                    <Col  className="cp-header-content">
                        <h2>百万现金大礼包 - 每日大放送</h2>
                        <p>每日签到领取AI津贴，仅当日有效，用于插件消耗使用，不可提现！</p>
                    </Col>
                    <Col md={3}className="cp-total-fund">
                        <div>活动累计发放</div>
                        <div className="cp-amount">
                            ¥{checkInSummary ? Math.floor(checkInSummary.allUsersTotalAmount).toLocaleString() : '0'}
                        </div>
                        <div>
                            {checkInSummary ? checkInSummary.allUsersTotal.toLocaleString() : '0'} 用户已参与 🔥
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={4}>
                        <div className="cp-sidebar">
                            <div className="cp-user-info">
                                <div className="cp-avatar">
                                    <img
                                        src={userInfo && userInfo.user?.avatar ? userInfo.user.avatar : "/images/default_user.svg"}
                                        alt="用户头像"/>
                                </div>
                                <div className="cp-user-details">
                                    <div
                                        className="cp-user-name">{formatUserName(userInfo?.user?.bindingMobile ? userInfo.user.bindingMobile : '微信用户')}</div>
                                    <div className="cp-user-id">用户ID: {userInfo?.user?.id || '--'}</div>
                                    <div className={getMemberTypeClass(userInfo?.vip?.level || 0)}>
                                        {getMemberTypeText(userInfo?.vip?.level || 0)}
                                    </div>
                                </div>
                            </div>

                            <div className="cp-check-in-status">
                                <div className="cp-status-item">
                                    <div className="cp-label">今日签到</div>
                                    <div className="cp-value">{todayChecked ? '已签到' : '未签到'}</div>
                                </div>
                                <div className="cp-status-item">
                                    <div className="cp-label">累计签到</div>
                                    <div className="cp-value">{checkInSummary ? checkInSummary.totalCheckIns : '0'}天
                                    </div>
                                </div>
                            </div>

                            <div className="cp-streak-progress">
                                <div className="cp-title">连续签到进度</div>
                                <div className="cp-progress-bar">
                                    <div
                                        className="cp-progress-fill"
                                        style={{width: `${streakProgress}%`}}
                                    ></div>
                                </div>
                                <div className="cp-days-indicator">
                                    {[1, 2, 3, 4, 5, 6, 7].map(day => (
                                        <div
                                            key={day}
                                            className={`cp-day-mark ${day <= streakDays ? 'active' : ''}`}
                                        >
                                            {day}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="cp-check-in-button">
                                <button
                                    className="cp-check-in-btn"
                                    onClick={handleCheckIn}
                                    disabled={todayChecked || loading}
                                >
                                    {loading ? '签到中...' : todayChecked ? '今日已签到' : '立即签到领福利'}
                                </button>
                                <div className="cp-check-in-reward">
                                    签到领取免费算力点津贴，每天都可以领取福利哦~
                                </div>
                            </div>

                            <div className="cp-records">
                                <div className="cp-title">签到记录</div>
                                <div className="cp-records-content">
                                    {recentHistory.map((record, index) => (
                                        <div className="cp-record-item" key={index}>
                                            <div className="cp-date">{record.date}</div>
                                            <div className="cp-amount">+{record.amount.toFixed(2)}元</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={8}>
                        <div className="cp-main-content">
                            <div className="cp-member-benefits">
                                <div className="cp-title">会员尊享福利</div>
                                <Row className="cp-benefit-cards">
                                    <Col lg={4} className={"mb-2"}>
                                        <div className="cp-benefit-card">
                                            <div className="cp-card-header">
                                                <div className="cp-icon">普通</div>
                                                <div className="cp-type">普通会员</div>
                                            </div>
                                            <div className="cp-benefit-item">每日签到获得 0.2元 算力点津贴</div>
                                            <div className="cp-benefit-item">可抵扣当日插件消耗</div>
                                        </div>
                                    </Col>
                                    <Col lg={4} className={"mb-2"}>
                                        <div className="cp-benefit-card">
                                            <div className="cp-card-header">
                                                <div className="cp-icon">VIP</div>
                                                <div className="cp-type">VIP会员</div>
                                            </div>
                                            <div className="cp-benefit-item">每日签到获得 0.5-1元 算力点津贴</div>
                                            <div className="cp-benefit-item">可抵扣当日插件消耗</div>
                                        </div>
                                    </Col>
                                    <Col lg={4} className={"mb-2"}>
                                        <div className="cp-benefit-card premium">
                                            <div className="cp-card-header">
                                                <div className="cp-icon">SVIP</div>
                                                <div className="cp-type">SVIP会员</div>
                                            </div>
                                            <div className="cp-benefit-item">每日签到获得 1-2元 算力点津贴</div>
                                            <div className="cp-benefit-item">可抵扣当日插件消耗</div>
                                        </div>
                                    </Col>

                                </Row>
                            </div>

                            <div className="cp-calendar-wrapper">
                                <div className="cp-title">签到日历</div>
                                <Row className="cp-day-grid">
                                    {createDayGrid().map((day, index) => (
                                        <Col xs={6} md={3} lg={2} xxl={2} className={"mb-3"}>
                                            <div
                                                key={index}
                                                className={`cp-day-item ${day.isToday ? 'today' : ''} ${day.isChecked ? 'checked' : ''}`}
                                            >
                                                <div className="cp-day-label">
                                                    {day.daysAgo === 0 ? '今日' : `${day.daysAgo}天前`}
                                                </div>
                                                <div className="cp-reward">
                                                    {day.reward ? `+${day.reward.toFixed(2)}元` : day.isChecked ? '0元' : '-'}
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="nta-activity-section">
                                <div className="nta-activity-header">
                                    <div className="nta-title-container">
                                        <h3 className="nta-section-title">任务中心</h3>
                                    </div>
                                    <div className="nta-subtitle">完成任务，领取专属奖励</div>
                                </div>

                                {tasks.length > 0 ? (
                                    tasks.map(task => (
                                        <div className="nta-task-card" key={task.id}>
                                            <div className="nta-task-content">
                                                <div className="nta-task-info">
                                                    <div className="nta-task-title">{task.name}</div>
                                                    <div className="nta-task-description">{task.description}</div>
                                                    <div className="nta-task-progress-container">
                                                        <div className="nta-task-progress-wrapper">
                                                            <div className="nta-task-progress-bar">
                                                                <div
                                                                    className="nta-task-progress-fill"
                                                                    style={{width: `${task.user_task_progress}%`}}
                                                                ></div>
                                                                <div className="nta-task-progress-glow"></div>
                                                            </div>
                                                            <div className="nta-task-progress-text">
                                                                {task.user_task_progress}%
                                                                ({getTaskStatusText(task.user_task_status)})
                                                            </div>
                                                        </div>
                                                        <div className="nta-task-actions">
                                                            <button
                                                                className={`nta-task-action-btn nta-start-btn ${task.user_task_status === 2 ? 'disabled' : ''}`}
                                                                onClick={() => handleStartTask(task.goto_url)}
                                                                disabled={task.user_task_status === 2}
                                                            >
                                                                {task.user_task_status === 0 ? '开始任务' :
                                                                    task.user_task_status === 1 ? '继续任务' : '已完成'}
                                                            </button>
                                                            <button
                                                                className={`nta-task-action-btn nta-claim-btn ${task.user_task_status !== 2 || task.user_reward_status === 1 ? 'disabled' : ''}`}
                                                                onClick={() => handleClaimTaskReward(
                                                                    task.id,
                                                                    task.name,
                                                                    task.reward_type,
                                                                    task.cash_amount,
                                                                    task.vip_days
                                                                )}
                                                                disabled={task.user_task_status !== 2 || task.user_reward_status === 1}
                                                            >
                                                                {task.user_reward_status === 1 ? '已领取' : '领取奖励'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="nta-task-reward-info">
                                                        奖励: {
                                                        task.reward_type === 1 ? (
                                                            <span
                                                                className="nta-cash-reward">{(task.cash_amount / 100).toFixed(2)}元</span>
                                                        ) : (
                                                            <span
                                                                className="nta-vip-reward">{task.vip_days}天VIP会员</span>
                                                        )
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="nta-no-tasks">
                                        <div className="nta-no-tasks-text">暂无任务</div>
                                    </div>
                                )}

                                <div className="nta-coming-soon">
                                    <div className="nta-coming-soon-text">更多精彩活动，敬请期待...</div>
                                    <div className="nta-coming-soon-stars">
                                        <div className="nta-star nta-star-1"></div>
                                        <div className="nta-star nta-star-2"></div>
                                        <div className="nta-star nta-star-3"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>


            </div>

            {/* 签到成功弹窗 */}
            <div className={`cp-modal-overlay ${showModal ? 'active' : ''}`}>
                <div className="cp-modal-container">
                    <div className="cp-modal-header">
                        <div className="cp-modal-close" onClick={handleCloseModal}>×</div>
                        <h2>签到成功</h2>
                        <p>恭喜您完成今日签到！</p>
                    </div>
                    <div className="cp-modal-body">
                        <div className="cp-reward-box" id="reward-container">
                            <div className="cp-reward-label">获得插件津贴</div>
                            <div className="cp-reward-amount">
                                {checkInResult && checkInResult.data ?
                                    `+${(checkInResult.data.total / 100).toFixed(2)}元` :
                                    '+1.2元'}
                            </div>
                            <div className="cp-reward-label">已存入您的账户</div>
                        </div>
                        <div style={{display: "none"}}>
                            今天是您连续签到的第<strong>{streakDays}</strong>天
                        </div>
                        <div className="cp-streak-info">
                            连续签到7天可获得额外奖励，再坚持{7 - streakDays > 0 ? 7 - streakDays : 0}天可获得额外奖励
                        </div>
                    </div>
                    <div className="cp-modal-footer">
                        <button className="cp-modal-btn" onClick={handleCloseModal}>太棒了！</button>
                    </div>
                    <div className="cp-confetti-container" ref={confettiContainerRef}>
                        {confetti.map(item => (
                            <div
                                key={item.id}
                                className={`cp-confetti cp-confetti-${item.color} cp-confetti-${item.shape}`}
                                style={{
                                    left: `${item.left}%`,
                                    width: `${item.size}px`,
                                    height: `${item.size}px`,
                                    animationDelay: `${item.delay}s`,
                                    transform: `rotate(${item.rotation}deg)`
                                }}
                            ></div>
                        ))}
                    </div>
                </div>
            </div>

            {/* 非会员提示弹窗 */}
            <div className={`cp-modal-overlay ${showNonMemberModal ? 'active' : ''}`}>
                <div className="cp-modal-container">
                    <div className="cp-modal-header non-member">
                        <div className="cp-modal-close" onClick={handleCloseNonMemberModal}>×</div>
                        <h2>会员专享特权</h2>
                        <p>尊敬的用户，签到活动仅对会员开放</p>
                    </div>
                    <div className="cp-modal-body">
                        <div className="cp-non-member-info">
                            <div className="cp-non-member-icon">🎁</div>
                            <div className="cp-non-member-text">
                                <h3>开通会员即可享受以下特权：</h3>
                                <ul>
                                    <li>每日签到获取插件津贴</li>
                                    <li>连续签到额外奖励</li>
                                    <li>会员专属AI功能</li>
                                    <li>更多会员专享权益</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="cp-modal-footer">
                        <button className="cp-modal-btn member-btn" onClick={handleBuyMembership}>
                            立即开通会员
                        </button>
                        <button className="cp-modal-btn-secondary" onClick={handleCloseNonMemberModal}>
                            暂不开通
                        </button>
                    </div>
                </div>
            </div>

            {/* 任务奖励弹窗 */}
            <div className={`nta-modal-overlay ${showTaskRewardModal ? 'active' : ''}`}>
                <div className="nta-modal-container">
                    <div className="nta-modal-header">
                        <div className="nta-modal-close" onClick={handleCloseTaskRewardModal}>×</div>
                        <h2>恭喜获得奖励</h2>
                        <p>{currentTaskReward?.name || '任务'} 完成！</p>
                    </div>
                    <div className="nta-modal-body">
                        <div className="nta-reward-box">
                            <div className="nta-reward-glow"></div>
                            {currentTaskReward?.rewardType === 1 ? (
                                <>
                                    <div className="nta-reward-label">获得现金奖励</div>
                                    <div className="nta-reward-amount">
                                        {currentTaskReward ? (currentTaskReward.cashAmount / 100).toFixed(2) : '0.00'}元
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="nta-reward-label">获得VIP会员</div>
                                    <div className="nta-reward-amount">
                                        {currentTaskReward?.vipDays || 0}天
                                    </div>
                                </>
                            )}
                            <div className="nta-reward-label">已存入您的账户</div>
                        </div>
                        {currentTaskReward?.rewardType === 2 && (
                            <div className="nta-reward-benefits">
                                <div className="nta-benefit-title">VIP特权已激活</div>
                                <div className="nta-benefit-item">
                                    <div className="nta-benefit-icon">✓</div>
                                    <div className="nta-benefit-text">每日签到获得插件津贴</div>
                                </div>
                                <div className="nta-benefit-item">
                                    <div className="nta-benefit-icon">✓</div>
                                    <div className="nta-benefit-text">会员专属AI功能</div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="nta-modal-footer">
                        <button className="nta-modal-btn" onClick={handleCloseTaskRewardModal}>太棒了！</button>
                    </div>
                    <div className="nta-confetti-container" ref={taskConfettiContainerRef}>
                        {taskConfetti.map(item => (
                            <div
                                key={item.id}
                                className={`nta-confetti nta-confetti-${item.color} nta-confetti-${item.shape}`}
                                style={{
                                    left: `${item.left}%`,
                                    width: `${item.size}px`,
                                    height: `${item.size}px`,
                                    animationDelay: `${item.delay}s`,
                                    transform: `rotate(${item.rotation}deg)`
                                }}
                            ></div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CheckInPage;